(function stickyCheckoutInit() {
  const CHECKOUT_VISITED_KEY = 'cc-has-reached-checkout-session';
  const stickyCheckoutBtn = document.querySelector('[data-sticky-checkout]');

  const setCheckoutVisited = () => {
    try {
      sessionStorage.setItem(CHECKOUT_VISITED_KEY, 'true');
    } catch (err) {
      // Ignore storage errors (private mode, blocked storage, etc.)
    }
  };

  const hasReachedCheckout = () => {
    try {
      return sessionStorage.getItem(CHECKOUT_VISITED_KEY) === 'true';
    } catch (err) {
      return false;
    }
  };

  const clearCheckoutVisited = () => {
    try {
      sessionStorage.removeItem(CHECKOUT_VISITED_KEY);
    } catch (err) {
      // Ignore storage errors (private mode, blocked storage, etc.)
    }
  };

  const isCheckoutTriggerElement = (element) => {
    if (!element) return false;

    const checkoutLink = element.closest('a[href*="/checkout"], a[href*="/checkouts/"]');
    if (checkoutLink) return true;

    const checkoutButton = element.closest('[name="checkout"]');
    if (checkoutButton) return true;

    return false;
  };

  const isCheckoutSubmit = (form, submitter) => {
    if (!form) return false;

    if (submitter && submitter.name === 'checkout') return true;

    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.includes('/checkout') || action.includes('/checkouts/')) return true;

    return false;
  };

  // Site-wide: remember checkout intent so the homepage-only button can show later.
  document.addEventListener('click', (event) => {
    if (!isCheckoutTriggerElement(event.target)) return;
    setCheckoutVisited();
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter || document.activeElement;
    if (!isCheckoutSubmit(event.target, submitter)) return;
    setCheckoutVisited();
  }, true);

  if (!stickyCheckoutBtn) return;

  const isCartPage = document.body.classList.contains('template-cart');
  if (isCartPage) return;

  const hasPlacedOrder = () => {
    const currentUrl = `${window.location.pathname}${window.location.search}`.toLowerCase();
    const referrer = (document.referrer || '').toLowerCase();
    const orderPlacedPattern = /\/thank_you|\/orders\/|order_status|\/order-received/;

    return orderPlacedPattern.test(currentUrl) || orderPlacedPattern.test(referrer);
  };

  const showStickyCheckout = async () => {
    if (hasPlacedOrder()) {
      clearCheckoutVisited();
      return;
    }

    if (!hasReachedCheckout()) return;

    try {
      const response = await fetch(`${theme.routes.cart}.js`, {
        credentials: 'same-origin'
      });
      if (!response.ok) return;

      const cart = await response.json();
      if (!cart || !cart.item_count) return;

      stickyCheckoutBtn.hidden = false;
    } catch (err) {
      // Fail silently and keep button hidden on network errors.
    }
  };

  showStickyCheckout();
})();
